import Scorm2004CMIModel from './Scorm2004CMIModel';

const ScormEvents = { 
    INITIALIZE: 'initialize', 
    CHANGE: 'change', 
    COMMIT: 'commit', 
    FINISH: 'finish' 
};

export class ScormRuntime2004 {

    /********************************************
     * Constructor
     * 
     * 'callbacks' can be one or all of:
     * initialize, change, commit, finish, error
     ********************************************/
    
    constructor( { CMIModel, debug = false, studentName = '', studentId = '', eventCallbacks = {} } ) {
        this.debug = debug;
        
        const newModel = JSON.parse( JSON.stringify( Scorm2004CMIModel ) );
        newModel.cmi.learner_name = studentName;
        newModel.cmi.learner_id = studentId;
 
        // If CMI model doesn't exist or is blank
        if ( !CMIModel || Object.keys( CMIModel ).length === 0 ) {
            this.model = Scorm2004CMIModel;
        } else {
            this.model = CMIModel;
        }

        this.eventCallbacks = eventCallbacks;
        
        this.debug && console.log( 'Initial CMIModel:', this.model );
    }
   
    /**************************
     * SCORM Events
     **************************/
    
    Initialize ( arg ) {
        this.debug && console.log( 'Initialized ScormRuntime2004', arg );
        
        this.triggerCallback( ScormEvents.INITIALIZE );
        
        return true;
    }

    Terminate ( arg ) {
        this.debug && console.log( 'Terminate:', arg );
        
        this.triggerCallback( ScormEvents.FINISH );
        
        return true;
    }

    Commit ( arg ) {
        this.debug && console.log( 'Commit:', arg );
        
        this.triggerCallback( ScormEvents.COMMIT );
        
        return true;
    }
        
    SetValue ( element, value ) {
        this.debug && console.log( 'SetValue:', element, value );

        const result = this.setCMIValue( element, value );
        this.triggerCallback( ScormEvents.CHANGE );

        return result;
    }
    
    GetValue ( element ) { 
        this.debug && console.log( `GetValue: ${ element }: ${ this.getCMIValue( element ) }` );
        
        return this.getCMIValue( element );
    }

    GetLastError() {
        return 0;
        // GetLastError() : CMIErrorCode – Returns the error code that resulted from the last API call.
        // TODO: Saving this for later useage
    }

    GetErrorString( errorCode ) {
        return '';
        // GetErrorString( errorCode : CMIErrorCode ) : string – Returns a short string describing the specified error code.
        // TODO: Saving this for later useage
    }

    GetDiagnostic( errorCode ) {
        return 0;
        // GetDiagnostic( errorCode : CMIErrorCode ) : string – Returns detailed information about the last error that occurred.
        // TODO: Saving this for later useage
    }

    /**************************
     * Event handlers
     **************************/
   
    triggerCallback( eventName ) {
        if ( !this.eventCallbacks[ eventName ] ) {
            this.debug && console.log( `Event callback ${ eventName } does not exist` );
            return;
        }

        this.eventCallbacks[ eventName ]( eventName, this.model );
    }

    /**************************
     * Utility Functions
     **************************/
    
    getCMIValue ( keyPath ) {
        let searchKeys;
        
        if ( keyPath === 'cmi.core.lesson_status' ) {
            searchKeys = 'cmi.completion_status'.split( '.' );
        } else {
            searchKeys = keyPath.split( '.' );
        }

        let index = 0;

        function getKey( JSObject ) {
            const fkey = JSObject[ searchKeys[ index ] ] ;
     
            if ( fkey === undefined ) {
                return undefined;
            }

            if ( typeof fkey === 'object' && fkey !== null && !Array.isArray( fkey ) && index < searchKeys.length - 1 ) {
                index++;
                return getKey( fkey );
            } else {
                return fkey;
            }
        } 

        const value = getKey( this.model );

        return value !== undefined ? value : '';
    }   
 
    setCMIValue( keyPath, newValue ) {
        let searchKeys;

        if ( keyPath === 'cmi.core.lesson_status' ) {
            searchKeys = 'cmi.completion_status'.split( '.' );
        } else {
            searchKeys = keyPath.split( '.' );
        }

        let index = 0;

        function getKey( JSObject ) {
            let fkey = JSObject[ searchKeys[ index ] ] ;
     
            if ( fkey === undefined ) {
                return undefined;
            }

            if ( typeof fkey === 'object' && fkey !== null && !Array.isArray( fkey ) && index < searchKeys.length - 1 ) {
                index++;
                return getKey( fkey );
            } else {
                JSObject[ searchKeys[ index ] ]  = newValue;
                return newValue;
            }
        }
        
        const value = getKey( this.model );

        return value !== undefined ? value : '';
    } 
}
